import React from 'react';

import {Typography} from '@mui/material';
import {useSubmitHandover} from '../../hooks/useSubmitHandover';

import {ConfirmationModal} from '../../components/Common/ConfirmationModal';
import {useReviewContext} from '../../contexts/ReviewContext';

export const HandoverSubmitValidationChecks = () => {
  const {
    catchSubmit: _catchSubmit,
    fullSubmit,
    setSubmissionStatus,
    softSubmit: _softSubmit,
    submissionStatus,
  } = useSubmitHandover();
  const {reviewValidation: review, allValid: _allValid} = useReviewContext();

  return (
    <>
      <ConfirmationModal
        open={submissionStatus === 'hasNoRequirements'}
        handleClose={() => setSubmissionStatus('awaiting')}
        title="Review - No requirements"
        message={
          <>
            There are no requirements on this review. <br />
            On submission, we will mark the review as &quot;No action&quot;.
            <br />
            {review?.reviewType === 'Annual' && (
              <Typography mt={2} mb={2}>
                A task will be created for your client services to send a review letter
                confirming the outcome to the client.
              </Typography>
            )}
            <br />
            Are you happy to full submit?
          </>
        }
        confirmAction={() => {
          setSubmissionStatus('awaiting');
          fullSubmit();
        }}
      />
      <ConfirmationModal
        open={submissionStatus === 'unfinalisedRequirements'}
        handleClose={() => setSubmissionStatus('awaiting')}
        title="Review - Unfinalised requirements"
        message="You have unfinalised requirements. Please finalise before submitting."
        confirmAction={() => {
          setSubmissionStatus('awaiting');
        }}
      />
      <ConfirmationModal
        open={submissionStatus === 'allRequirementsFinalised'}
        type="allRequirementsFinalised"
        handleClose={() => setSubmissionStatus('awaiting')}
        title="Review - Finalised Requirements"
        message="Are you sure you want to submit this review? Once submitted, you will be unable to edit the requirements, notes or tasks in OneView."
        confirmAction={() => {
          setSubmissionStatus('awaiting');
          fullSubmit();
        }}
      />
    </>
  );
};
